import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LegalFooter } from "./Impressum";
import { usePageMeta } from "../hooks/usePageMeta";

const agbSections = [
  {
    title: "Die Bahnen",
    testId: "agb-bahnen",
    items: [
      "Betreten Sie den Anlauf erst, wenn alle Pins aufgestellt sind und der Rechen (Abräumer) wieder nach oben gefahren ist. Haftung im Schadensfall bei Missachtung!",
      "Der Anlauf darf nur mit Bowlingschuhen betreten werden. Nehmen Sie keine Getränke und Speisen mit auf den Anlauf.",
      "Das Betreten der Bahnen ist nicht gestattet. Ab der Foul Line (schwarze Linie) sind die Bahnen geölt. Rutschgefahr/Unfallgefahr!",
      "Es ist verboten, Körperteile oder anderer Gegenstände in die Ballrückläufe zu stecken. Das Sitzen auf dem Balltisch, das Klettern auf der Schutzhaube der Ballhebemaschine ist zu unterlassen.",
      "Mit Bowlingschuhen darf das Center nicht verlassen werden. Bei Nichteinhaltung behalten wir uns vor, Ihnen 25 € in Rechnung zu stellen.",
      "Bei Glasbruch an den Bahnen ist der Spielbetrieb bis zur Reinigung zu unterbrechen. Sollten wir für den Bruch nicht verantwortlich sein entsteht kein Anspruch auf Minderung des Spielpreises oder der Spielzeit.",
      "Wenn die Bahn ausgeschaltet ist, dürfen keine Bälle geworfen werden. Haftungspflicht bei Beschädigung.",
      "Bei auftretenden technischen Störungen an der Bahn oder am Ballrücklauf, ist das Spielen einzustellen und das Personal zu informieren.",
      "Kindern und Jugendlichen bis 14 Jahren, ist das Betreten der Halle nur in Begleitung einer volljährigen Aufsichtsperson gestattet.",
      "Nach Spielende bitte Sitzgruppenbereich an den Bahnen verlassen und andere Sitzmöglichkeiten im Bistrobereich benutzen.",
    ],
  },
  {
    title: "Reservierungen",
    testId: "agb-reservierungen",
    items: [
      "Der Reservierungsanspruch verfällt spätestens bei einer Überschreitung der Anfangszeit um 15 Minuten.",
      "Wir behalten uns vor, nicht in Anspruch genommene Reservierungen mit 30 € pro Bahnstunde zu berechnen.",
      "Der Anspruch auf eine bestimmte Bahn ist ausgeschlossen. Wir behalten uns vor, die Bahnbelegung abweichend vom Reservierungsplan vorzunehmen.",
      "Jeder Gast ist verpflichtet, sich an die Reservierungszeiten zu halten. Eine Verlängerung oder Verschiebung der Mietzeit ist bei anschließender Bahnbelegung ausgeschlossen.",
      "Die Stornierung einer Einzelbahn ist bis 10 Stunden vor Spielbeginn kostenlos möglich. Die Stornierung von mind. 6 Bahnstunden ist bis 24 Stunden vor Spielbeginn kostenlos möglich.",
      "Die Stornierung von mind. 12 Bahnstunden ist bis 48 Stunden vor Spielbeginn kostenlos möglich. Danach fällt eine Ausfallgebühr in Höhe von 30 € pro Bahn und Stunde an.",
      "Bei Reservierungen mit Buffet und mindestens 20 Personen ist eine Stornierung bis eine Woche vor der Veranstaltung kostenlos möglich. Danach berechnen wir wie folgt: 40 % (60%) bei einer Absage bis 6 Tage (4 Tage) vorher. Bei einer Absage von 3 oder weniger Tagen vorher, berechnen wir Ihnen 100 % des Preises bezogen auf Bowling und Buffet bzw. den Paketpreis.",
    ],
  },
  {
    title: "Die Abrechnung",
    testId: "agb-abrechnung",
    items: [
      "Das Bowling und die Schuhe werden nach dem Spielen am Counter bezahlt. Wenn nicht gesondert gekennzeichnet, sind die Schuhe im Bahnpreis nicht enthalten.",
      "Getränke und Speisen sind beim Service Personal zu bezahlen.",
      "Wir behalten uns das Recht vor, 200 und 500 Euro Scheine nicht anzunehmen.",
      "Ein verspäteter Spielbeginn oder eine technische Störung während des Bahnbetriebes, berechtigt nicht zur Reduzierung des Spielpreises, wenn die Ausfallzeit unter 10 Min. beträgt.",
      "Zeitabrechnung bedeutet, dass die Bahnen pro Minute berechnet werden.",
      "Bei reservierten Bahnen muss die Spielzeit mind. 90% der reservierten Zeit betragen. Wir behalten uns vor, die reservierte Zeit zu berechnen.",
    ],
  },
  {
    title: "Sonstiges",
    testId: "agb-sonstiges",
    items: [
      "Gutscheine und Aktionen sind vor Spielbeginn vorzuzeigen. Nur so kann eine Einlösung sichergestellt werden.",
      "Für eigene Bälle und Garderobe übernehmen wir grundsätzlich keine Haftung.",
      "Das Mitbringen von Speisen und Getränken ist verboten. Das Mitbringen von Kuchen bei Geburtstagsfeiern ist nach vorheriger Absprache möglich.",
      "Wir behalten uns das Recht vor, sichtlich angetrunkenen Gästen den Eintritt zu verwehren.",
      "Unsere Bowlinganlage wird videoüberwacht.",
      "Es gilt das Jugendschutzgesetz. Demnach ist der Konsum von Alkohol für unter 18 jährige eingeschränkt.",
      "Mutwillige Sachbeschädigungen und Verunreinigungen werden zur Anzeige gebracht.",
      "Die vom Bowlingcenter bekannt gegebenen Öffnungszeiten sind Richtzeiten. Die Geschäftsleitung behält sich vor, die bekannt gegebenen Öffnungszeiten je nach Auslastung zu verkürzen bzw. zu verlängern.",
      "Die Bowlingbahnen werden gesamt pro Bahn und nicht pro Spieler am Counter abgerechnet. Die Preise sind in bar auszugleichen und sofort fällig. Es gelten die vom Bowlingcenter am Counter bekannt gegebenen Preise als vereinbart. 1 Tag vor und an Feiertagen gelten die für Samstag gültigen Preise und Bedingungen. Angebotspreise können zu jeder Zeit rückgängig gemacht werden.",
    ],
  },
];

export default function AGB() {
  usePageMeta({
    title: "AGB – Pirate Bowling Center Velburg",
    description: "Allgemeine Geschäftsbedingungen und Hausordnung des Pirate Bowling Center Velburg.",
    noindex: true,
  });
  return (
    <div className="min-h-screen bg-navy text-cream">
      <div className="border-b border-gold/10 bg-navy-deep/80 backdrop-blur-xl sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-cream-muted hover:text-gold transition-colors text-sm font-space-grotesk"
            data-testid="back-home-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          <span className="font-unbounded text-xs font-bold gold-text tracking-widest uppercase">
            Pirate Bowling Center
          </span>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <div className="mb-12">
          <div className="skull-divider mb-6">
            <span className="font-space-grotesk text-xs text-gold tracking-[0.3em] uppercase px-3">Rechtliches</span>
          </div>
          <h1
            className="font-unbounded text-4xl md:text-5xl font-black text-cream mb-4"
            data-testid="agb-headline"
          >
            AGBs
          </h1>
          <p className="font-inter text-sm text-cream/50 leading-relaxed">
            Hausordnung und allgemeine Geschäftsbedingungen<br />
            Jeder Gast erklärt sich mit dem Betreten unseres Bowlingcenters grundsätzlich mit der Hausordnung einverstanden.
          </p>
          <p className="font-space-grotesk text-sm text-gold/70 mt-3">
            Wir danken für Ihr Verständnis und wünschen viel Spaß!
          </p>
        </div>

        <div className="space-y-5">
          {agbSections.map((sec) => (
            <div
              key={sec.testId}
              className="glass border border-gold/10 rounded-2xl p-7 md:p-8"
              data-testid={sec.testId}
            >
              <h2 className="font-unbounded text-base font-bold text-cream mb-5">{sec.title}</h2>
              <ul className="space-y-3">
                {sec.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="w-1.5 h-1.5 rounded-full bg-gold/50 mt-2 flex-shrink-0" />
                    <span className="font-inter text-sm text-cream/65 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <p className="font-inter text-xs text-cream/25 text-center pt-4">
            Stand: April 2026
          </p>
        </div>
      </div>

      <LegalFooter />
    </div>
  );
}
